<template>
  <div class="page-box">
    <PageSwiper location="NEWS" />

    <div class="page-nav">
      <img src="@/assets/home-icon.png" @click="gotoHome" />
      <div style="cursor: pointer" @click="gotoHome">首页 ></div>
      <div class="text">新闻中心</div>
    </div>

    <div class="news-list">
      <div class="news-item" v-for="(item, index) in newsList" :key="index">
        <div class="news-innner">
          <img :src="$utils.getFileHttpUrl(item.img)" @click="gotoDetail(item)" />
          <div class="news-content" @click="gotoDetail(item)">
            <div class="title">{{ item.title }}</div>
            <div class="content" v-html="$utils.escape2Html(item.content)"></div>
            <div class="time-row">
              <div class="time">{{ item.time | timeFilter }}</div>
              <div class="text">查看详情</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="page">
      <Pagination
        background
        :page-size="pageSize"
        :current-page.sync="pageNo"
        layout="prev, pager, next, jumper"
        :total="total"
        hide-on-single-page
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import PageSwiper from '@/components/PageSwiper'
import { Pagination } from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
export default {
  components: { PageSwiper, Pagination },
  data() {
    return {
      newsList: [],
      pageNo: 1,
      pageSize: 20,
      total: 0
    }
  },
  created() {
    this.getData(1)
  },
  methods: {
    gotoHome() {
      this.$router.replace({ name: 'home' })
    },
    getData(pageNo) {
      this.$http.getAction('/portal/api/v1/news', { pageNo: pageNo, pageSize: this.pageSize }).then((res) => {
        if (res.success) {
          this.newsList = res.data.records
          this.total = Number(res.data.total)
        }
      })
    },
    handleCurrentChange(val) {
      this.getData(val)
    },
    gotoDetail(record) {
      this.$router.push({name: 'newsDetail', params: {id: record.id}})
    }
  },
  filters: {
    timeFilter(text) {
      return text?.split(' ')[0]
    }
  }
}
</script>
<style lang="scss" scoped>
.page-box {
  padding-bottom: 60px;

  .page-nav {
    display: flex;
    align-items: center;
    width: 1200px;
    height: 80px;
    margin: 0 auto;
    font-weight: 500;
    font-size: 14px;
    color: #898989;
    line-height: 16px;
    img {
      width: 20px;
      height: 20px;
      margin-right: 15px;
      cursor: pointer;
    }
    .text {
      padding-left: 6px;
      color: #333333;
    }
  }

  .news-list {
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    
    .news-item {
      width: 270px;
      height: 340px;
      background: #ffffff;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.08);
      margin-right: 40px;
      margin-bottom: 40px;
      &:nth-of-type(4n) {
        margin-right: 0;
      }
      .news-innner {
        display: flex;
        flex-direction: column;
        height: 100%;
        border: 1px solid #ffffff;
        &:hover {
          border: 1px solid #1392EE;
          .news-content {
            .title {
              color: #0282DE;
              text-decoration-line: underline;
            }
          }
        }
      }
      img {
        width: 100%;
        height: 165px;
        object-fit: cover;
      }
      .news-content {
        padding: 15px 18px;
        flex: 1;
        display: flex;
        flex-direction: column;
        cursor: pointer;

        .title {
          font-weight: bold;
          font-size: 18px;
          color: #121212;
          line-height: 21px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .content {
          padding-top: 15px;
          font-weight: 500;
          font-size: 14px;
          color: #636466;
          line-height: 16px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .time-row {
          margin-top: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .time {
            font-weight: 500;
            font-size: 12px;
            color: #a2a3a5;
          }
          .text {
            font-weight: 500;
            font-size: 12px;
            color: #0282de;
          }
        }
      }
    }
  }

  .page {
    width: 1200px;
    margin: 0 auto;
    text-align: right;
    padding-top: 20px;
  }
}
</style>
